import { BoxProps } from '@chakra-ui/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IRiskAction {
  id?: string;
  isDoc?: boolean;
  isDocumentFixed?: boolean;
  isCheckedOff?: boolean;
  canCheckOff?: boolean;
  onCheckOffRisk?: () => void;
  iconProps?: IRiskIcon;
  boxProps?: BoxProps;
}

export interface IRiskIcon {
  icon: IconProp;
  label: string;
  colorScheme: 'gray' | 'orange' | 'cyan';
}

export enum RiskMessage {
  RISK = 'The system highlighted something that you may want to take a closer look at',
  REUPLOADED = 'The student uploaded a document which required an update',
  ACTIONREQUIRED = 'The document uploaded does not meet all the requirements',
  ACKNOWLEDGED = 'The highlighted items have been marked as OK by a staff member',
}
